import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacilitiesIconActive = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M3 20V5C3 3.89543 3.89543 3 5 3H11C12.1046 3 13 3.89543 13 5V9H19C20.1046 9 21 9.89543 21 11V20C21 20.5523 20.5523 21 20 21H13H4C3.44772 21 3 20.5523 3 20Z",
			fill: "#90D5CA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 14H10M6 7H10M6 18H10M16 13H18M16 16H18",
			stroke: "#FFFF",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFacilitiesIconActive);
export { ForwardRef as ReactComponent };
